<template>
  <div>
    <div class="modal-backdrop fade show"></div>

    <div
      class="modal fade show modal-dialog-centered modal-dialog-scrollable"
      style="padding-right: 12px; display: block;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isAdd ? 'Новая запись' : 'Редактирование' }}.
            </h5>

            <button type="button" class="close" @click="$emit('cancel')">
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="modal-body">
            <form>
              <div class="form-group">
                <label>Дата</label>
                <input type="text" class="form-control" v-model="date"/>
                <small class="form-text text-muted">формат: YYYY-MM-DD</small>
              </div>

              <div class="form-group">
                <label>Текст</label>
                <textarea class="form-control" v-model="text" rows="12"></textarea>
              </div>
            </form>

            <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-primary" @click="submitForm">
              {{ isAdd ? 'Добавить' : 'Обновить' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../../utils/formatDate';
import Flash from '../../../common/Flash';

export default {
  name: 'ClientConclusionAnamnesisForm',

  components: {Flash},

  props: ['anamnesis'],

  data() {
    return {
      error: '',
      text: '',
      date: formatDate(new Date(), 'y-m-d'),
    };
  },

  created() {
    if (typeof this.anamnesis !== 'undefined') {
      this.text = this.anamnesis.text;
      this.date = formatDate(this.anamnesis.date, 'y-m-d');
    }
  },

  computed: {
    isAdd() {
      return typeof this.anamnesis === 'undefined';
    },
  },

  methods: {
    submitForm() {
      this.error = '';

      if (typeof this.text !== 'string' || this.text.trim() === '') {
        this.error = 'Нужно заполнить текст';
      }

      if (typeof this.date !== 'string' || this.date.trim() === '') {
        this.error = 'Дата не указана';
      }

      if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.date) !== true) {
        this.error = 'Дата указана неправильно';
      }

      if (this.error !== '') {
        return;
      }

      const data = {
        text: this.text,
        date: this.date
      };

      if (typeof this.anamnesis !== 'undefined') {
        data.id = this.anamnesis.id;
      }

      this.$emit('submit', data);
    },
  },
};
</script>
